import { TextWithContentModel } from './model/TextWithContentModel';
import { TextWithContentPreviewHeader } from './widget/TextWithContentPreviewHeader';
import { YoutubePreview } from './widget/PreviewComponents/YoutubePreview';
import { MultipleImagesPreview } from './widget/PreviewComponents/MultipleImagesPreview';
import { CoverImagePreview } from './widget/PreviewComponents/CoverImagePreview';
import { previewScrollbar } from 'shared-widget-components/src/components/preview/previewScrollbar';

interface TextWithContentProps {
  content: TextWithContentModel;
  languageCode: string;
}

/**
 * @description This component is displayed as a preview in the Admin editor and as a widget in the webshop.
 * @param0 content TextWithContentModel; The widgetState aka the date of the widget.
 * @param1 languageCode string; The language code represents the language that is currently used.
 * @returns {JSX.Element} The TextWithContent component
 */

export const TextWithContent = ({ content, languageCode }: TextWithContentProps) => {
  return (
    <div className='w-full previewScrollbar h-full overflow-hidden min-[350px]:py-4 md:py-6 lg:py-10' style={{ background: content.sectionColor }}>
      <style>{previewScrollbar}</style>
      <div className={`w-full max-w-[1240px] h-fit mx-auto flex min-[350px]:flex-col ${content.mediaType === 1 ? 'sm:flex-row' : 'md:flex-row'} sm:gap-4 min-[350px]:px-0 sm:px-2 md:px-4`}>
        <TextWithContentPreviewHeader content={content} languageCode={languageCode} />
        <YoutubePreview content={content} languageCode={languageCode} />
        <MultipleImagesPreview content={content} />
        <CoverImagePreview content={content} />
      </div>
    </div>
  );
};
